/**
 * Median's JavaScript Bridge (median.onesignal.login/logout) ties the
 * current device to a OneSignal external id, so server/jobs/pushNotifications.js
 * can send a push notification to a specific Sharetribe user without us
 * capturing or storing a device token ourselves. This bridge object only
 * exists when the site is running inside the Median-wrapped app, never on
 * the regular website or during server-side rendering.
 */

const getMedianOneSignal = () => {
  if (typeof window === 'undefined') {
    return null;
  }
  return window.median?.onesignal || null;
};

export const medianOneSignalLogin = externalId => {
  const oneSignal = getMedianOneSignal();
  if (oneSignal && externalId) {
    oneSignal.login(externalId);
  }
};

export const medianOneSignalLogout = () => {
  const oneSignal = getMedianOneSignal();
  if (oneSignal) {
    oneSignal.logout();
  }
};
